import React from "react";

export const Button = ({
  text,
  type,
  action,
  icon,
  disabled = false,
  arrow,
}) => {
  return (
    <button
      className={`c-button ${type}`}
      onClick={() => action && action()}
      disabled={disabled}
    >
      {icon && (
        <span>
          <img src={icon} alt="" />
        </span>
      )}
      {text}
      {arrow && (
        <span className="arrow">
          <img src={arrow} alt="" />
        </span>
      )}
    </button>
  );
};
